import { Menu } from '@headlessui/react';
import classNames from 'classnames';

import { Icon } from '@shared/ui';
import { IFIleEntity } from '@widgets/Files/model/types/fileEntity.interface';

import cls from './FolderDropdown.module.css';
import { useFolderDropdown } from './useFolderDropdown';

interface FolderDropdownProps {
    folderInfo: IFIleEntity;
}
export const FolderDropdown = ({ folderInfo }: FolderDropdownProps) => {
    const { t, onChangeModalMode, onChangeCurrentFolderInDropdown, onDownloadObjHandler } =
        useFolderDropdown(folderInfo.id);

    return (
        <Menu>
            <Menu.Button
                onClick={(event) => {
                    event.stopPropagation();
                    onChangeCurrentFolderInDropdown(folderInfo.id);
                }}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }}
                className={cls.menu}
            >
                <Icon iconName="filesDropdownDots" />
            </Menu.Button>
            <Menu.Items className={cls.menuItems}>
                <Menu.Item className={cls.item}>
                    <span
                        onClick={async (event) => {
                            event.stopPropagation();
                            onDownloadObjHandler();
                        }}
                    >
                        <Icon iconName="filesDownload" />
                        {t('Dropdown.return.item.save')}
                    </span>
                </Menu.Item>
                <Menu.Item className={cls.item}>
                    <span
                        onClick={(event) => {
                            event.stopPropagation();
                            onChangeModalMode('folderEdit');
                            onChangeCurrentFolderInDropdown(folderInfo.id);
                        }}
                    >
                        <Icon iconName="filesEdit" />
                        {t('Dropdown.return.item.rename')}
                    </span>
                </Menu.Item>
                <Menu.Item className={classNames(cls.item, cls.delete)}>
                    <span
                        onClick={(event) => {
                            event.stopPropagation();
                            onChangeModalMode('folderDelete');
                        }}
                    >
                        <Icon iconName="filesDelete" />
                        {t('Dropdown.return.item.delete')}
                    </span>
                </Menu.Item>
            </Menu.Items>
        </Menu>
    );
};
